// extracted by mini-css-extract-plugin
export var activeIcon = "FavoriteButton-module--activeIcon--2r7nK";
export var icon = "FavoriteButton-module--icon--2AUrw";
export var inactiveIcon = "FavoriteButton-module--inactiveIcon--DbVck";
export var isActive = "FavoriteButton-module--isActive--FcVO-";
export var wrapper = "FavoriteButton-module--wrapper--30Ncs";